export default function getQrCode(Uuid, locale) {
    return process.env.VUE_APP_URL + "" + locale + "/qr-verify/" + Uuid;
  }